module.exports = __webpack_public_path__ + "static/img/pic_coop01.e527a23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/productOperation/liveOperation/pic_coop01.png
// module id = clRh
// module chunks = 0